var styles = {"box":"RewardStatus_box_1lwid_1","md":"RewardStatus_md_1lwid_13","complete":"RewardStatus_complete_1lwid_21","incomplete":"RewardStatus_incomplete_1lwid_24","inactive":"RewardStatus_inactive_1lwid_30"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
